import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';
import CachedIcon from '@material-ui/icons/Cached';

import CustomDialog from './inputs/CustomDialog'
// import TemplatePreview from './TemplatePreview'
import InstaTable from './InstaTable'
import RedeemIcon from './Mui/RedeemIcon'

import {
  coupons_index,
  publish_coupon,
  unpublish_coupon,
  businesses_select,
  preferences_index,
  revoke_coupon,
  reset_campaign_token,
  clear_coupon,
  delete_coupon,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.coupon
  return {
    coupon: state.coupon,
    coupons: items,
    pagination: pagination,
    totals: totals,
    businesses: state.business.select_items,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getCoupons: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( coupons_index(page, per_page, filters, sort, order) ),
    publishCoupon: (coupon_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(publish_coupon(coupon_id, index, page, per_page, filters, sort, order)),
    unpublishCoupon: (coupon_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(unpublish_coupon(coupon_id, index, page, per_page, filters, sort, order)),
    deleteCoupon: (coupon_id, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(delete_coupon(coupon_id, page, per_page, filters, sort, order)),
    revokeCoupon: (coupon_id, index=true, page=1, per_page=10, filters={}, sort="", order="")  => dispatch(revoke_coupon(coupon_id, index, page, per_page, filters, sort, order)),
    resetCampaignToken: (coupon_id, index, page=1, per_page=10, filters={}, sort="", order="") => dispatch( reset_campaign_token(coupon_id, true, page, per_page, filters, sort, order) ),
    getPreferences: () => dispatch( preferences_index() ),
    getBusinesses: () => dispatch( businesses_select() ),
    clearCoupon: () => dispatch( clear_coupon() ),
    setPath: path => dispatch( set_path(path) ),
  }
}

class ConnectedCouponsIndex extends React.Component {
  state={
    current_coupon: {},
    current_view: 'all',
    merge_filters: {},
    initFilters: {},
    current_id: undefined,
    filterState: {},
    dialogState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "valid_from" || field === "valid_to" || field === "created_at" ) {
      renderText = item[field] ? new Date(item[field]).toLocaleDateString() : ''
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'campaign_token') {
      renderText = item['business_id'] ? item[field] : ''
    } else if (field === 'discount') {
      renderText = item.discount > 0 ? `${parseInt(item.discount * 100, 10)} %` : `${item.value.toFixed(2)} €`
    } else if (field === 'limit' || field === 'usage' ) {
      renderText = item[field]
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { item.status === "draft" && this.editLink(item) }
          { item.status === "draft" && this.publishLink(item, state) }
          { (item.status === "published" || item.status === "revoked") && this.unpublishLink(item, state) }
          { item.status !== "revoked" && this.revokeLink(item, state) }
          { item.status === "revoked" && (!item.usage || item.usage === 0) && this.deleteLink(item, state) }
          { this.resultsLink(item) }
          { item.business_id && this.resetTokenLink(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    let initFilters = {}
    const { getCoupons, getBusinesses, getPreferences } = this.props
    if (this.props.location && this.props.location.state && this.props.location.state.business) {
      initFilters = {
        ...initFilters,
        business: this.props.location.state.business
      }
    }
    this.setState({initFilters: initFilters})

    getCoupons(1, 10, initFilters, '', '')
    getBusinesses()
    getPreferences()
    this.props.setPath('coupons')
}

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.coupon.fetching && !this.props.coupon.fetching && this.props.coupon.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  editLink = item => {
    const {id} = item
    return (
      <Link to ={`/coupons/${id}/edit`} className="action-btn" title="Edit" onClick={this.props.clearCoupon}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
      </Link>
    )
  }

  publishLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Publish Coupon" onClick={e=>{
        e.preventDefault()
        this.props.publishCoupon(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
      </Link>
    )
  }

  unpublishLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    const title = item.status === "revoked" ? "Recover to draft" : "Unpublish Coupon"
    const icon  = item.status === "revoked" ? "restore_page" : "insert_drive_file"
    return (
      <Link to="" className="action-btn" title={title}onClick={e=>{
        e.preventDefault()
        this.props.unpublishCoupon(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>{icon}</Icon>
      </Link>
    )
  }

  revokeLink = (item, state) => {
    const {id} = item
    const {filters, sort, order, page, per_page} = state
    return (
      <Link to="" className="action-btn" title="Revoke Coupon" onClick={e=>{
        e.preventDefault()
        this.props.revokeCoupon(id, true,  page, per_page, filters, sort, order)
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete</Icon>
      </Link>
    )
  }


  deleteLink = (item, state) => {
    const {id} = item
    const {current_user} = this.props
    // const {filters, sort, order, page, per_page} = state
    if (
      current_user.role === "admin"
    ) {
      return (
        <Link to="" className="action-btn" title="Permanently delete" onClick={e=>{
            e.preventDefault()
            this.setState({showDialog: true, current_id: id, filterState: state})
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
        </Link>
      )
    }
    return ''
  }

  resetTokenLink = (item, state) => {
    const { id } = item
    return (
      <Link to="" className="action-btn" title="Reset Campaign Token" onClick={e=>{
        e.preventDefault()
        this.setState({showResetDialog: true, current_coupon: item, dialogState: state})
      }}>
        <CachedIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '18px'}} />
      </Link>
    )
  }

  resetTokenAction = () => {
    const { mounted, current_coupon, dialogState } = this.state
    if (mounted && current_coupon.id) {
      const { page, per_page, filters, sort, order } = dialogState
      const { id } = current_coupon
      this.props.resetCampaignToken(id, true, page, per_page, filters, sort, order)
      this.hideResetDialog()
    }
  }

  destroy = id => {
    const {filters, sort, order, page, per_page} = this.state.filterState
    this.props.deleteCoupon(id, page, per_page, filters, sort, order)
    this.hideDialog()
    this.setState({filterState: {}})
  }

  hideDialog() {
    this.setState({showDialog: false, current_coupon: {}})
  }

  hideResetDialog() {
    this.setState({showResetDialog: false, current_coupon: {}})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'published') {
      icon = 'check_circle'
    } else if (status === 'draft') {
      icon = 'insert_drive_file'
    } else if (status === 'expired') {
      icon = 'timer_off'
    } else if (status === 'consumed') {
      icon = "done_all"
    } else if (status === 'revoked') {
      icon = "delete"
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  showPreview = item => {
    // this.setState({showPreview: true, current_template: template})
  }

  resultsLink = (item) => {
    const {longid, tests_taken} = item
    if (tests_taken === 0) {
      return (
        <Link to='' style={{padding: '15px 5px 5px 5px', cursor: 'not-allowed'}} title="Coupon has not been redeemed yet" disabled onClick={e => {e.preventDefault()}}>
          <RedeemIcon style={{color: 'rgba(0,0,0,0.6)', fontSize: '16px'}} />
        </Link>
      )
    }

    return (
      <Link to={`/tests/coupon?coupon_id=${longid}`} className="action-btn" title="Test Results" target="_blank">
        <RedeemIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} />
      </Link>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { coupons, pagination, totals, businesses } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'name', disablePadding: true, label: 'Name' },
      { id: 'description', disablePadding: true, label: 'Description', disableSort: true },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'discount', disablePadding: true, label: 'Discount', disableSort: true },
      { id: 'valid_from', disablePadding: true, label: 'Issue' },
      { id: 'valid_to', disablePadding: true, label: 'Expiry' },
      { id: 'business_name', disablePadding: true, label: 'Business' },
      { id: 'limit', disablePadding: true, label: 'Max use' },
      { id: 'usage', disablePadding: true, label: 'Redeemed' },
      { id: 'created_at', disablePadding: true, label: 'Creation' },
      { id: 'campaign_token', label: 'Campaign Token', disableSort: true },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "search", filter_type: "search" },
      { name: "business", filter_type: "select", valueField: "name", collection: businesses },
      { name: "valid_from", filter_type: "date", prefix: "valid_from_", startLabel: "Issue from" },
      { name: "valid_to", filter_type: "date", prefix: "valid_to_", startLabel: "Expiry from" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "published", label: "Published", value: totals.published },
      { name: "draft", label: "Draft", value: totals.draft },
      { name: "expired", label: "Expired", value: totals.expired },
      { name: "consumed", label: "Consumed", value: totals.consumed },
      { name: "revoked", label: "Revoked", value: totals.revoked },
    ]

    return (
      <div id="feedbacks-wrapper" className={this.props.coupon.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Coupons
          </Typography>
          <CustomOutlinedButton
            component={Link}
            to="/coupons/new"
            className="buttonnoto c-blue align-self-center"
            onClick={e=> this.props.setPath("addcoupon")}
            >Add Coupon
          </CustomOutlinedButton>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={coupons}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="ID, name, description"
          init_filters={this.state.initFilters}
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getCoupons.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="coupons"
          addClassField="status"
        />
        {
          // <TemplatePreview
          //   id="preview-template-dialog"
          //   isopen={this.state.showPreview}
          //   template={this.state.current_template}
          //   handleClose={this.hideDialog.bind(this)}
          // />
        }
        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Coupon?"
        >
          This action cannot be undone
        </CustomDialog>
        <CustomDialog
          id="reset-dialog"
          fullScreen = {false}
          isopen={this.state.showResetDialog}
          handleClose={this.hideResetDialog.bind(this)}
          handleAccept={this.resetTokenAction.bind(this)}
          title="Reset Campaign Token?"
        >
          This will invalidate all running campaigns for this coupon.
        </CustomDialog>
      </div>
    )
  }
}

const CouponsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedCouponsIndex)

export default withStyles(styles)(CouponsIndex)



// WEBPACK FOOTER //
// ./src/js/components/CouponsIndex.js